@if (column?.dataType) {
  @switch (column?.dataType) {
    @case ('Number') {
      {{ transformNumber() }}
    }
    @case ('TextArray') {
      {{ transformTextArray() }}
    }
    @case ('DateTime') {
      {{ column?.columnFormatKey === 'DateOnly' ? transformDate() : transformDateTime() }}
    }
    @case ('ChangeRecord') {
      <span [innerHTML]="transformChangeRecord()"></span>
    }
    @default {
      {{ value ? (value.toString() | stripHtml) : noValue }}
    }
  }
}
